/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgCapabilitiesCostManagement { 
    /**
     * Policies enabled for scanning comma separated.
     */
    scan_enabled_policies?: string;
    /**
     * Policies enabled for cleanup comma separated.
     */
    cleanup_enabled_policies?: string;
}

